<template>
  <div class="car-performance" :class="isMobile ? '' : 'fill-section-1080'">
    <img class="img-cover" :src="imgUrlPrefix + picName" alt="巴丹吉林" />
    <div class="car-content fade-up">
      <p class="car-content-tag" >让越野更可靠</p>
      <p class="car-content-title">久经市场 实战验证</p>
      <p class="car-content-desc" v-html="descTxt"></p>
    </div>
    <div class="car-performance-items">
      <div  class="car-performance-item fade-up" v-for="(item, index) in performanceList" :key="index">
        <p class="performance-num">{{ item.num }}&nbsp;<span v-if="!isMobile">{{ item.unit }}</span></p>
        <p class="performance-name">{{ isMobile ? item.name + '（' + item.unit + '）' :item.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { fadeAnimate, destroyFadeAnimate } from '../../utils/animation.js'
export default {
  name: 'CarPerformance',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    fadeAnimate();
  },
  beforeDestroy() {
    destroyFadeAnimate();
  },
  computed: {
    picName() {
      return this.isMobile ? 'm-sec14_1.jpg' : 'sec14_1.jpg'
    },
    descTxt() {
      return this.isMobile ? 
        '不靠噱头，靠实绩<br>经366项性能测试，100万＋公里验证<br>叠加±40℃耐候<br>5500米高海拔及1万公里越野专项测试<br>在实战中持续优化核心部件，让可靠看得见' : '不靠噱头，靠实绩<br>经366项性能测试，100万＋公里验证<br>叠加±40℃耐候、5500米高海拔及1万公里越野专项测试<br>在实战中持续优化核心部件，让可靠看得见'
    },
  },
  data() {
    const imgUrlPrefix = '/assets/images/badainJaran/'
    return {
      imgUrlPrefix,
      performanceList: [
        { num: '366' , unit: '项', name: '性能测试'},
        { num: '100W＋' , unit: '公里', name: '路跑验证'},
        { num: '±40' , unit: '℃', name: '耐候叠加'},
        { num: '10000' , unit: '公里', name: '越野专项测试'},
      ],
    }
  },
}
</script>

<style lang="less" scoped>
.car-performance {
  position: relative;
  .car-content {
    position: absolute;
    top: 120px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-weight: @fw2;
    .car-content-tag {
      font-size: clamp(12px, 0.83vw, 16px);
      color: rgba(255, 255, 255, 0.7);
    }
    .car-content-title {
      font-weight: @fw1;
      font-size: clamp(32px, 2.5vw, 48px);
      color: #ffffff;
      margin-top: 0.83vw;
    }
    .car-content-desc {
      font-size: clamp(16px, 1.25vw, 24px);
      color: rgba(255, 255, 255, 0.7);
      margin-top: 0.83vw;
      line-height: 1.5;
    }
  }
  .car-performance-items {
    position: absolute;
    bottom: 90px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    width: 73vw;
    justify-content: space-between;
    .car-performance-item {
      font-weight: @fw2;
      color: #ffffff;
      .performance-num {
        font-size: clamp(46px, 3.33vw, 64px);
        span {
          font-size: clamp(24px, 1.85vw, 36px);
        }
      }
      .performance-name {
        font-size: clamp(16px, 1.25vw, 24px);
        text-align: center;
      }
    }

  }
}
@media (max-width: @mobile-width) {
  .car-performance {
    .car-content {
      width: 89.33vw;
      top: 14.68vw;
      .car-content-tag {
        font-size: 2.67vw;
      }
      .car-content-title {
        font-size: 8.53vw;
      }
      .car-content-desc {
        font-size: 4.26vw;
      }
    }
    .car-performance-items {
      bottom: 18.67vw;
      width: 100%;
      left: 0;
      transform: none;
      flex-wrap: wrap;
      row-gap: 6.4vw;
      .car-performance-item {
        width: 50%;
        text-align: center;
        .performance-num {
          font-size: 8.53vw;
        }
        .performance-name {
          font-size: 3.2vw;
        }
      }
    }
  }
}
</style>